/* tslint:disable:no-console */

// Service worker DISABLED - causes caching issues preventing updates
// See https://transunion.atlassian.net/wiki/spaces/F3/pages/3149103925/demo.iovation.com+Caching+Issue+Investigation for details

// Unregister any existing service workers
// TODO: Remove this code after 2026-01-03 (30 days after deployment)
// By then, most active users will have visited and unregistered their service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister().then((success) => {
        if (success) {
          console.log('Service worker unregistered successfully - caching issues resolved');
        }
      });
    }
  }).catch((error) => {
    console.error('Error unregistering service worker:', error);
  });
}
